// src/plugin/globalPlugin.ts
import { App, h, render } from 'vue'
import Loading from './Loading.vue'
import Toast from './Toast.vue'


let loadingInstance: any = null
let toastInstance: any = null

function mountLoading() {
  if (!loadingInstance) {
    const vnode = h(Loading)
    const container = document.createElement('div')
    document.body.appendChild(container)
    render(vnode, container)
    loadingInstance = vnode.component?.exposed
  }
  return loadingInstance
}
function mountToast() {
  if (!toastInstance) {
    const vnode = h(Toast)
    const container = document.createElement('div')
    document.body.appendChild(container)
    render(vnode, container)
    toastInstance = vnode.component?.exposed
  }
  return toastInstance
}

export default {
  install(app: App) {
    // 全局注册 Loading 和 Toast 组件
    app.component('Loading', Loading)
    app.component('Toast', Toast)
    // 全局方法
    app.config.globalProperties.$loading = {
      show: (...args: any[]) => mountLoading()?.show(...args),
      hide: () => mountLoading()?.hide()
    }
    app.config.globalProperties.$toast = {
      show: (msg: string, time?: number, expand?: boolean) => mountToast()?.show(msg, time, expand),
      hide: () => mountToast()?.hide()
    }
    // 示例：全局注册一个自定义指令
    app.directive('focus', {
      mounted(el) {
        el.focus()
      }
    })
  }
}
